import { CorporateOnly } from '@/middleware/EdverumClientMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

/**
 * Consolidated corporate "Enrollment & Progress" destination. Merges learner
 * progress visibility with enrollment-management actions into one page.
 * Corporate-only; other clients keep the separate Gradebook + Enrollments pages.
 */
export default [
    {
        name: 'course-progress-view',
        path: '/courses/:courseId/progress',
        component: () => import('@/pages/courses/progress/CourseProgress.vue'),
        props: true,
        beforeEnter: CorporateOnly,
        meta: {
            title: 'Progress',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'course enrollment page' },
        },
    },
];
